var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.111,
    height: 24.088,
    viewBox: "0 0 30.111 24.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.779 -163.343) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.881,48.173V71.639l-7.969-7.969a1.505,1.505,0,1,0-2.129,2.129l10.539,10.539a1.5,1.5,0,0,0,2.129,0L186.99,65.8a1.505,1.505,0,1,0-2.128-2.129l-7.969,7.969V48.173a1.505,1.505,0,1,0-3.011,0Z",
    transform: "translate(0)",
    fill: "#00a9ce"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.b01a5d5ca3bf8897217de8a7028afeeb.svg";
export { ForwardRef as ReactComponent };